import PropTypes from 'prop-types';

import ContentfulRichText from './contentfulRichText';

import Section from 'legacy/components/section';
import Heading from 'legacy/components/heading';
import Flex from 'legacy/components/flex';
import Box from 'legacy/components/box';
import { contentfulRichTextType } from 'types';

const TextBlock = ({ heading, headingPosition, content, renderOptions }) => (
  <Section>
    <Section.Inner>
      {headingPosition === 'left' && (
        <Flex flexWrap="wrap" mx={-3}>
          <Box width={[1, null, null, 1 / 2]} px={3}>
            <Heading variant={['h4', null, null, 'h3']}>{heading}</Heading>
          </Box>
          <Box width={[1, null, null, 1 / 2]} px={3}>
            <ContentfulRichText
              content={content?.json}
              links={content?.links}
              renderOptions={renderOptions}
            />
          </Box>
        </Flex>
      )}
      {headingPosition === 'right' && (
        <Flex flexWrap="wrap" mx={-3}>
          <Box order={[1, null, null, 0]} width={[1, null, null, 1 / 2]} px={3}>
            <ContentfulRichText
              content={content?.json}
              links={content?.links}
              renderOptions={renderOptions}
            />
          </Box>
          <Box order={[0, null, null, 1]} width={[1, null, null, 1 / 2]} px={3}>
            <Heading variant={['h4', null, null, 'h3']}>{heading}</Heading>
          </Box>
        </Flex>
      )}
      {headingPosition === 'center' && (
        <Box mx="auto" maxWidth={720}>
          <Heading variant={['h4', null, null, 'h3']}>{heading}</Heading>
          <ContentfulRichText
            content={content?.json}
            links={content?.links}
            renderOptions={renderOptions}
          />
        </Box>
      )}
      {!headingPosition && (
        <Box mx="auto" maxWidth={720}>
          <ContentfulRichText
            content={content?.json}
            links={content?.links}
            renderOptions={renderOptions}
          />
        </Box>
      )}
    </Section.Inner>
  </Section>
);
TextBlock.propTypes = {
  heading: PropTypes.string,
  headingPosition: PropTypes.oneOf(['left', 'right', 'center']),
  content: contentfulRichTextType.isRequired,
  renderOptions: PropTypes.shape({
    renderNode: PropTypes.object,
    renderMark: PropTypes.object,
  }),
};

TextBlock.defaultProps = {
  heading: '',
  headingPosition: null,
  renderOptions: null,
};

export default TextBlock;
